module.exports = __webpack_public_path__ + "img/yilianGl7.ed996b69.png";